export function preventRefresh() {
	window.onbeforeunload = function () {
		return 'WARNING! Changes will be lost upon leaving the page.';
	};
}

export function allowRefresh() {
	window.onbeforeunload = null;
}
